import React, { Fragment } from "react";
import { Drawer } from 'antd';
import BranchForm from '../../containers/BranchForm';
import ClientForm from '../../containers/ClientForm';
import RoomsForm from '../../containers/RoomsForm';

function AntDrawer({visible, setVisible, drawerBody, profile }){
    function onClose(){
        setVisible(visible = false)
    }

    function renderBody(){
        switch(drawerBody) {
            case "ADD_BRANCH":
                return <BranchForm/>
            case "ADD_CLIENT":
                return <ClientForm profile={profile}/>
            case "ADD_ROOM":
                return <RoomsForm/>
            default:
              return null;
        }
    }

    return(
        <Fragment>
            <Drawer
                title="Cadastrar"
                width={920}
                placement="right"
                closable={false}
                onClose={onClose}
                visible={visible}
            >
                {renderBody()}
            </Drawer>
        </Fragment>
    )
}

export default AntDrawer;


// WEBPACK FOOTER //
// ./src/components/common/AntDrawer.jsx